import React from 'react'

const HomeMiddle = () => 
	<div className='home-middle'>
		<div className='house'/>
		<div className='rainbow'/>
			<div className='childs'>
			<div className='child1'><div className='child-in'/></div>
			<div className='child2'><div className='child-in'/></div>
			<div className='child3'><div className='child-in'/></div>
			<div className='child4'><div className='child-in'/></div>
			<div className='child5'><div className='child-in'/></div>
			<div className='child6'><div className='child-in'/></div>
			</div>
		<div className='slogan'/>
	</div>
	
export default HomeMiddle


// WEBPACK FOOTER //
// ./src/components/extensions/HomeMiddle.js